/** استخراج پیام‌های خطای Yup برای نمایش به کاربر */
export function collectYupValidationMessages(err) {
  if (!err) return ["لطفاً فیلدهای الزامی را تکمیل کنید."];

  if (Array.isArray(err.inner) && err.inner.length > 0) {
    const seen = new Set();
    return err.inner
      .map((e) => e.message)
      .filter((msg) => {
        if (!msg || seen.has(msg)) return false;
        seen.add(msg);
        return true;
      });
  }

  if (err.message && !err.message.includes("concat()")) {
    return [err.message];
  }
  return ["لطفاً فیلدهای الزامی را تکمیل کنید."];
}

export const assistedRegistrationFieldLabels = {
  initialConditionsAccepted: "تأیید شرایط احداث",
  powerPlantType: "نوع نیروگاه",
  locationUsageType: "کاربری محل نصب",
  plantCapacity: "ظرفیت نیروگاه",
  installableAreaSquareMeter: "مساحت قابل نصب",
  electricBoillNumber: "شناسه قبض برق",
  installationType: "نوع محل نصب",
  unitCount: "تعداد واحد",
  needsLoan: "نیاز به وام",
  loanGuaranteeChequeIntent: "وضعیت چک صیادی",
  guarantorFirstName: "نام ضامن",
  guarantorLastName: "نام خانوادگی ضامن",
  guarantorNationalCode: "کد ملی ضامن",
  guarantorMobile: "موبایل ضامن",
  ownershipStatus: "وضعیت مالکیت",
  platformAcquaintanceSource: "نحوه آشنایی",
  applicantGoalFlags: "اهداف متقاضی",
  xPoint: "موقعیت روی نقشه (عرض جغرافیایی)",
  yPoint: "موقعیت روی نقشه (طول جغرافیایی)",
  provinceId: "استان",
  cityId: "شهرستان",
  address: "آدرس",
  postalCode: "کد پستی",
  locationInput: "لینک یا مختصات موقعیت",
  electricBoillUrl: "تصویر یا PDF قبض برق",
  nationalCardUrl: "تصویر روی کارت ملی",
  nationalCardBackUrl: "تصویر پشت کارت ملی",
  plantInstallImage1Url: "عکس اول محل نصب",
  plantInstallImage2Url: "عکس دوم محل نصب",
  boardConsentDocumentUrl: "رضایت‌نامه هیئت‌مدیره",
  authorizedRepresentativeLetterUrl: "نامه معرفی نماینده",
  agreementDocumentUrl: "تفاهم‌نامه همکاری",
  firstName: "نام",
  lastName: "نام خانوادگی",
  nationalCode: "کد ملی",
  telephon: "تلفن ثابت",
  email: "ایمیل",
};

export function formatValidationErrorList(err) {
  if (!err?.inner?.length) {
    return collectYupValidationMessages(err);
  }

  const seenPaths = new Set();
  const seenMessages = new Set();

  return err.inner
    .map((e) => {
      if (!e.message) return null;

      // یک پیام برای هر دو مختصات کافی است
      if (e.path === "yPoint" && err.inner.some((x) => x.path === "xPoint")) {
        return null;
      }

      const label = assistedRegistrationFieldLabels[e.path];
      const line = label ? `${label}: ${e.message}` : e.message;

      const dedupeKey = e.path || e.message;
      if (seenPaths.has(dedupeKey) || seenMessages.has(e.message)) return null;
      seenPaths.add(dedupeKey);
      seenMessages.add(e.message);

      return line;
    })
    .filter(Boolean);
}
